import {
  pVal,
  obj2KeyVal,
  deltaDTW,
  deltaDTWN,
  checkKelasRunningWithTime,
  checkKelasRunningST,
  checkKelasRunningMaxDate,
  checkKelasRunning,
  parseIsAfter,
  parseIsBefore,
  parse0,
  parse7,
  toD,
  toDT,
  toST,
  combineWaktu
} from "@/tools";

const Consts = {
  install(Vue) {
    // 4. add an instance method
    Vue.prototype.$tools = {
      pVal,
      obj2KeyVal,
      deltaDTW,
      deltaDTWN,
      checkKelasRunningWithTime,
      checkKelasRunning,
      checkKelasRunningST,
      checkKelasRunningMaxDate,
      parseIsAfter,
      parseIsBefore,
      parse0,
      parse7,
      toD,
      toDT,
      toST,
      combineWaktu
    };
  }
};

export default Consts;
